import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import Title from "./Title";
import styled from "styled-components";

const About = () => {
  return (
    <Wrapper>
      <Title title="about me" />
      <StaticImage
        src="../../images/majhi.jpg"
        layout="fixed"
        placeholder="tracedSVG"
        width={100}
        height={100}
        alt="author"
        className="img"
      />
      <p>
        Hi, I'm Sumesh Majhi. A software engineer, open source creator and
        technical writer.
      </p>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  text-align: center;
  p {
    color: var(--clr-grey-5);
  }
  .img {
    border-radius: 50%;
    margin: 0 auto;
    margin-bottom: 1rem;
  }
`;
export default About;
